var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('ul',_vm._l((_vm.groupList),function(group){return _c('li',{key:group._id},[_c('h1',[_vm._v(" "+_vm._s(group)+" ")])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }